export default __webpack_public_path__ + "static/WirelessCommunicationsFacilitiesOrdinances5G-43b1033e5efd86a946a7a14a8022aeeb.jpg";